import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { firebase as fb, helpers } from 'redux-firebasev3';

import Loading from './components/Loading';
import ErrorPageRequiresAuthentication
from './components/ErrorPageRequiresAuthentication';

const { isLoaded, pathToJS } = helpers;

@fb()
@connect(
  ({ firebase }) => ({
    auth: pathToJS(firebase, 'auth')
  })
)
export default class RequiresAuthentication extends Component {
  static propTypes = {
    auth: PropTypes.object,
    children: PropTypes.node,
  }

  render() {
    const { auth, children } = this.props;

    const isLoggedIn = isLoaded(auth) && auth && auth.uid;

    if (!isLoggedIn || isLoaded(auth)) {
      if (!isLoaded(auth)) {
        return <Loading />;
      } else if (!isLoggedIn) {
        return <ErrorPageRequiresAuthentication />;
      }
    }

    return children;
  }
}



/** WEBPACK FOOTER **
 ** ./src/RequiresAuthentication.jsx
 **/